export enum AppianTransactionTypes {
  TRANSFER = 'Transfer',
  GIFT = 'Gift',
  TRANSITION = 'Transition',
  DTC_TRANSFER = 'DTC Transfer',
}
